<template>
  <base-modal
    title="Duplicate Report"
    :id="id"
    :value="value"
    @shown="clear"
    @input="$emit('input', $event)"
  >
    <form data-vv-scope="d-report">
      <div class="form-group" :class="{ 'has-error': errors.has('d-report.name') }">
        <label for="formname">Report Name</label>
        <input id="formname" class="form-control" name="name" type="text" v-validate="'required'" v-model="name">
        <span v-show="errors.has('d-report.name')" class="help-block">{{ errors.first('d-report.name') }}</span>
      </div>
      <div class="form-group" :class="{ 'has-error': errors.has('d-report.description') }">
        <label for="formdesc">Report Description</label>
        <textarea id="formdesc" class="form-control" name="description" type="text" v-validate="'required'" v-model="description"></textarea>
        <span v-show="errors.has('d-report.description')" class="help-block">{{ errors.first('d-report.description') }}</span>
      </div>
    </form>
    <template #footer>
      <button class="btn green mt-ladda-btn ladda-button duplicate-report-modal-btn" @click.prevent="submitDuplicate" data-style="expand-left">
        <span class="ladda-label">Duplicate Report</span>
      </button>
    </template>
  </base-modal>
</template>

<script>
import {mapActions} from 'vuex';

import BaseModal from "../BaseModal";

export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    reportId: {
      required: true,
    },
  },
  data () {
    return {
      id: 'duplicate-report-modal',
      name: '',
      description: ''
    }
  },
  methods: {
    ...mapActions({
      duplicateReportAction: 'DUPLICATE_REPORT_ACTION',
    }),
    clear() {
      this.name = '';
      this.description = '';
      this.$validator.reset();
    },
    submitDuplicate() {
      this.$validator.validateAll('d-report').then((result) => {
        if (result) {
          const context = Ladda.create(document.querySelector('.duplicate-report-modal-btn'));
          const data = {id: this.reportId, name: this.name, description: this.description, context};
          this.duplicateReportAction(data).then(() => {
            this.$emit('save');
            $(`#${this.id}`).modal('hide');
          });
        }
      });
    }
  },
  components: {BaseModal},
  emits: ['save', 'input'],
}
</script>



// WEBPACK FOOTER //
// DuplicateReportModal.vue?25e76411